<template>
  <div class="staking-dao-container">
    <CCard>
      <CCardHeader>
        <CRow>
          <CCol md="12" sm="12">
            <h1>{{ $t('STAKING_DAO_PAGE_TITLE') }}</h1>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <SearchInstanceHeader :onSearch="onSearch"></SearchInstanceHeader>
        <StakingDaoInstanceList :items="items" :activePage="activePage" :limit="limit"></StakingDaoInstanceList>
        <StakingPagination
          :limit="limit"
          :total="total"
          :activePage="activePage"
          @changePage="onChangePage"
          @changePageSize="onChangePageSize"
        />
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import _ from 'lodash';
import SearchInstanceHeader from '@/components/StakingDao/SearchInstanceHeader';
import StakingPagination from '@/components/StakingPagination';
import { endpoints, env } from '@/constants';
import responseHelper from '@/utils/response-helper';
import StakingDaoInstanceList from '@/components/StakingDao/StakingDaoInstanceList';

export default {
  name: 'StakingDao',
  components: {
    StakingPagination,
    SearchInstanceHeader,
    StakingDaoInstanceList,
  },
  data() {
    return {
      items: [],
      filterData: {},
      total: 0,
      limit: env.app.pageSize,
      activePage: 1,
    };
  },
  computed: {
    offset() {
      return (this.activePage - 1) * this.limit;
    },
    pages() {
      return Math.ceil(this.total / this.limit);
    },
  },
  async mounted() {
    this.isLoading = false;
  },
  methods: {
    async getStakingDaoInstances(data) {
      data = data || {};
      this.filterData = {
        ...this.filterData,
        ...data,
      };
      const filterData = this.filterData;

      try {
        const params = {
          limit: this.limit,
          offset: this.offset,
          status: filterData.status || null,
        };
        const result = await this.$http.get(endpoints.getStakingDaoInstanceList, { params });
        const items = result.data.items || [];
        this.items = items;

        this.total = result.data.total;
      } catch (err) {
        const msg = err.message ? err.message : err;
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('STAKING_DAO_TITLE_NOTIFY_ERROR'),
          text: responseHelper.getErrorMessage(msg),
        });
      }
    },
    async onChangePage(page) {
      this.activePage = page;

      this.getStakingDaoInstances();
    },
    async onChangePageSize(value) {
      this.limit = value;
      this.activePage = 1;

      this.getStakingDaoInstances();
    },
    async onSearch(searchData) {
      const data = searchData;
      this.activePage = 1;

      this.getStakingDaoInstances(data);
    },
  },
};
</script>
<style lang="scss">
.staking-dao-container {
  padding: 0 24px;
  @media screen and (max-width: 1024px) {
    padding: 0 15px;
  }

  .card {
    > .card-header {
      border-bottom: none;
      padding-bottom: 0px;

      h1 {
        color: #657187;
        font-size: 18px;
        font-weight: 600;
        line-height: 34px;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
